import { Copy, Trash2 } from 'lucide-react';

type BlockToolbarProps = {
  onMoveUp: () => void;
  onMoveDown: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  disabled?: boolean;
};

export function BlockToolbar({ onMoveUp, onMoveDown, onDuplicate, onDelete, disabled }: BlockToolbarProps) {
  return (
    <div className='ee-blocktools' onClick={(e) => e.stopPropagation()}>
      <button type='button' title='Move up' onClick={onMoveUp} disabled={disabled}>
        ▲
      </button>
      <button type='button' title='Move down' onClick={onMoveDown} disabled={disabled}>
        ▼
      </button>
      <button type='button' title='Duplicate' onClick={onDuplicate} disabled={disabled}>
        <Copy size={12} />
      </button>
      <button type='button' title='Delete' className='is-danger' onClick={onDelete} disabled={disabled}>
        <Trash2 size={12} />
      </button>
    </div>
  );
}
